/**
 * Created by Paul Olle 25/01/2022
 */
import {CloudObject, register, defineProperty} from 'olympe';

/**
 * A class representing a purchase request Json Cloud Object
 */
export class PRCloudObject extends CloudObject {
    /**
     *
     * @return {string}
     */
    getPRJson() {
        return this.get(PRCloudObject.jsonProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observePRJson($) {
        return this.observe($, PRCloudObject.jsonProp);
    }

    /**
     * @override
     * Converts Business props to JS object
     */
    toObject() {
        return {
            co: this,
            tag: this.getTag(),
            json: JSON.parse(this.getPRJson()),
        };
    }
}
// Hardcoded tags
register('017c3c68f9d613431edb', PRCloudObject);
PRCloudObject.jsonProp = defineProperty('017c3c692bc5a0be871c');
